import * as JSZip from 'jszip';
import {Document} from './document.model';

export class ZipSaisine {

    constructor(
        public name: string,
        public zip?: JSZip,
        public documents?: Document[]
    ) {}

    get percentCompleted(): string {
        return (this.documents.length > 0) ? ((Object.keys(this.zip.files).length / (this.documents.length + 1)) * 100).toFixed(0) : '0';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/download/zip.model.ts